export default "__VITE_ASSET__BjF7rMt8__"